export function calendarExt() {

    function init(){
        calendarEventsListener();
        formCallback($(".calendar-checker"));
    }

    function formCallback($this){
        $this.on("change", function (e) {
            e.preventDefault();
            var $checked = e.target.id;

            $(this).find("label").each(function () {
                var $form           = $(this).parents("form");
                var $main_parent    = $(this).parents(".table-calendar");
                var $from_n         = $(this).attr("data-from");
                var $to_n           = $(this).attr("data-to");
                var $from           = $from_n.split("-").join("");
                var $to             = $to_n.split("-").join("");

                if($checked == $(this).find("input").attr("id"))
                {
                    $from_n = moment($from_n).format('DD-MM-YYYY');
                    $to_n = moment($to_n).format('DD-MM-YYYY');
                    $form.find("[name='date_range']").val($from_n+' - '+$to_n);
                    $(this).addClass("checked");
                    $(this).find("input").prop("checked", true);
                    $($main_parent).find(".date-row td").removeAttr("class");
                    $($main_parent).find(".date-row td").each(function () {
                        var $cur_date = $(this).attr("data-numb").split("-").join("");
                        if($from <= $cur_date && $cur_date <= $to){
                            $(this).addClass("active-td");
                        }
                    });

                    $this.submit();
                } else {
                    $(this).removeAttr("class");
                    $(this).find("input").prop("checked", false);
                }
            });

            //$this.submit();
        });
    }


    function calendarEventsListener(){

        $(document).on("click", ".date-row td", function () {
            var $form = $(this).parents(".table-calendar").find(".calendar-dates-events form");
            if ($(this).parent(".date-row").hasClass("select-dates")) {
                $(this).addClass("active-td");
                var days_f = $(this).parent(".date-row").find("td.active-td:first").attr("data-numb");
                var days_l = $(this).parent(".date-row").find("td.active-td:last").attr("data-numb");
                $(this).parent(".date-row").find("td").each(function (k, el) {
                    var $data_el = parseInt($(el).attr("data-numb").split("-").join(""));
                    if ($data_el > parseInt(days_f.split("-").join("")) && $data_el < parseInt(days_l.split("-").join(""))){
                        $(el).addClass("active-td");
                    }
                });

                $(this).parent(".date-row").removeClass("select-dates");
                $form.find("#chek_custom").prop("checked", true).removeAttr("disabled");
                $form.find("[for='chek_custom']").addClass("checked").siblings().removeAttr("class");

                days_f = moment(days_f).format('DD-MM-YYYY');
                days_l = moment(days_l).format('DD-MM-YYYY');
                $form.find("[name='date_range']").val(days_f+' - '+days_l);
                $form.submit();

            } else {
                $(this).parent(".date-row").find("td").removeAttr("class");
                $(this).parent(".date-row").addClass("select-dates");
                $(this).addClass("active-td");
            }
        });

        $(document).on("click", ".header-row", function () {
            $(this).siblings(".date-row").removeClass("select-dates");
            $(this).siblings(".date-row").find("td").removeAttr("class");

        });

        $(document).on("click", ".year-row", function () {
            $(this).siblings(".date-row").removeClass("select-dates");
            $(this).siblings(".date-row").find("td").removeAttr("class");
        });
    }

    init();
}


// WEBPACK FOOTER //
// ./assets/js/modules/calendar.js